import { combineReducers } from "redux";
import * as actionTypes from "../../../folder/list/actionTypes";
import initialState from "../../../../reducers/initialState";

const listReducer = (state = initialState.responsibleChangeFolders.list, action) => {
  switch (action.type) {
    case actionTypes.LOAD_RESPONSIBLE_FOLDERS_STARTED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };
      return result;
    }

    case actionTypes.LOAD_RESPONSIBLE_FOLDERS_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };
      return result;
    }

    case actionTypes.LOAD_RESPONSIBLE_FOLDERS_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

const reducer = combineReducers({
  list: listReducer
});

export default reducer;
